import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { DatatableService } from '../../../shared/services/datatable.service';
import { Router } from '@angular/router';
import { DatatableComponent, DataTablePagerComponent } from '@swimlane/ngx-datatable';
import { IMyDpOptions } from 'mydatepicker';
import { SpringDatatablePagination } from '../../../shared/services/spring-integration/pagination/spring-datatable-pagination';
import { SpringDatatablePaginationService } from '../../../shared/services/spring-integration/pagination/spring-datatable-pagination.service';
import { HttpParams } from '@angular/common/http';
import * as moment from 'moment';
import { HistoricoVendasService } from './historico-vendas.service';
import { EncriptyUtilService } from '../../../shared/services/encripty-util.service';
import { ModalNotaFiscalComponent } from './modal-nota-fiscal/modal-nota-fiscal.component';
import { NbDialogService } from '@nebular/theme';
import { NgxSpinnerService } from 'ngx-spinner';
import { NotificationsService } from 'angular2-notifications';
import { DateUtilService } from '../../../shared/services/date-util.service';


@Component({
  selector: 'ngx-historico-vendas',
  templateUrl: './historico-vendas.component.html',
  styleUrls: ['./historico-vendas.component.scss']
})
export class HistoricoVendasComponent implements OnInit {

  @ViewChild('myTable', null)
  public myTable: DatatableComponent

  @ViewChild('tablePager', null)
  public tablePager: DataTablePagerComponent;

  public datatablePagination: SpringDatatablePagination = new SpringDatatablePagination()

  public formListaSimulacao = null;
  public listaStatus = null;
  public tableLimit = 12;
  public rowData : any;
  public listModeloCaputra: Array<any>;
  public listTipoTransacao: Array<any>;
  public listBandeira: Array<any>;
  public listModalidade: Array<any>;
  public customLogin = null;

  myDatePickerOptions: IMyDpOptions = {
    dateFormat: 'dd/mm/yyyy',
    showClearDateBtn: false,
    openSelectorOnInputClick: true,
    showTodayBtn: false,
    allowSelectionOnlyInCurrentMonth: false,
    dayLabels: { su: "Dom", mo: "Seg", tu: "Ter", we: "Qua", th: "Qui", fr: "Sex", sa: "Sab" },
    monthLabels: { 1: "Jan", 2: "Fev", 3: "Mar", 4: "Abr", 5: "Mai", 6: "Jun", 7: "Jul", 8: "Ago", 9: "Set", 10: "Out", 11: "Nov", 12: "Dez" },
    firstDayOfWeek: "su",
    //disableUntil: { year: new Date().getFullYear(), month: new Date().getMonth() + 1, day: new Date().getDate() - 1 }

  };

  constructor(
    private formBuilder: FormBuilder,
    private datatableService: DatatableService,
    private router: Router,
    private paginationService: SpringDatatablePaginationService,
    private service: HistoricoVendasService,
    private encriptyService: EncriptyUtilService,
    private dialogService: NbDialogService,
    public spinnerService: NgxSpinnerService,
    public notificationService: NotificationsService,
    private dateUtilService: DateUtilService,
  ) {

    this.paginationService.setDatatablePagination(this.datatablePagination);

    this.listaStatus = [

      {
        status: 'PENDENTE',
        descricao: 'PENDENTE'
      },
      {
        status: 'EXPIRADO',
        descricao: 'EXPIRADO'
      },
      {
        status: 'CONFIRMADO',
        descricao: 'CONFIRMADO'
      },
      {
        status: 'CANCELADO',
        descricao: 'CANCELADO'
      },
      {
        status: 'ESTORNADO',
        descricao: 'ESTORNADO'
      },
      {
        status: 'SIMULADO',
        descricao: 'SIMULADO'
      },
    ];

    this.listModeloCaputra = [{
      descricao: 'TEF_TI/WEBTEF'
    },{
      descricao: 'GERTEC/SDK-ADIQ'
    }];

    this.listTipoTransacao = [{
      descricao: 'VENDA'
    },{
      descricao: 'ESTORNO'
    }];

    this.listBandeira = [{
      descricao: 'MASTERCARD'
    },{
      descricao: 'ELO'
    },{
      descricao: 'VISA'
    }];

    this.listModalidade = [{
      descricao: 'CREDITO',
    },{
      descricao: 'DEBITO',
    }];

    this.formListaSimulacao = this.formBuilder.group({

      status: [null],
      modeloCaptura: [null],
      tipoTransacao: [null],
      bandeira: [null],
      modalidade: [null],
      dataInicio: [null],
      dataFim: [null]
    });



  }

  setSortParams(sortArray: any): string {
    if (sortArray && sortArray != null && sortArray.length > 0 ) {
      let dataToOrder: any = sortArray[0];
      return ''.concat(dataToOrder.prop, ',', dataToOrder.dir);
    }
    return ''.concat('dataCadastro', ',', 'asc');
  }

  listaVenda(data?: any, page?: any, sorts?: any) {
    let enterpriseFederalId: string = this.encriptyService.decriptyBySecretKey(
      localStorage.getItem('bway-enterprise-federal-id')
    );

    let params = new HttpParams();
    let sortData: any = this.setSortParams(sorts);

    params = params.append('sort', sortData);
    params = params.append('size', String(this.tableLimit))

    if (page && page != null) {
       params = params.append('page', String(page - 1));
    }


    if(data && data.dataInicio != null){
      let dataInicio: string = this.dateUtilService.datepickerTransformDate(data.dataInicio, 'YYYY-MM-DD');
      params = params.append('dataInicio',dataInicio)
    }

    if(data && data.dataFim  != null){
      let dataFim: string = this.dateUtilService.datepickerTransformDate(data.dataFim, 'YYYY-MM-DD');
      params = params.append('dataFim', dataFim)
    }

    if(data && data.modeloCaptura){
      params = params.append('modeloCaptura', data.modeloCaptura)
    }

    if(data && data.tipoTransacao){
      params = params.append('tipoTransacao', data.tipoTransacao)
    }

    if(data && data.bandeira){
      params = params.append('bandeira', data.bandeira)
    }

    if(data && data.modalidade){
      params = params.append('modalidade', data.modalidade)
    }

    params = params.append('cpfCnpj', enterpriseFederalId);

    this.spinnerService.show();
    this.service.searchTransacoes(params, (response => {
      this.rowData = response.content

      this.paginationService.setInfo(response)
      this.spinnerService.hide()
    }), (err)=>{
      this.spinnerService.hide()
      this.notificationService.error('Não foi possível carregar informação.')
    });

  }

  showCardModal(data: string) {
    this.dialogService.open(ModalNotaFiscalComponent, {
      context: {
        recibo: data,
      },
    });
  }

  limparFiltro(){
    this.formListaSimulacao.controls['modeloCaptura'].setValue(null);
    this.formListaSimulacao.controls['tipoTransacao'].setValue(null);
    this.formListaSimulacao.controls['bandeira'].setValue(null);
    this.formListaSimulacao.controls['modalidade'].setValue(null);
    this.formListaSimulacao.controls['dataInicio'].setValue(null);
    this.formListaSimulacao.controls['dataFim'].setValue(null);
  }


  ngOnInit() {

    let resCustom = localStorage.getItem('bway-customLogin');
    this.customLogin = JSON.parse(resCustom);
    document.title = this.customLogin.title;
    this.datatableService.subscribeTable(this.myTable);
  }

  previousPage() {
    this.router.navigate(['/iot-dashboard']);
  }

  getButtonPrimaria() {
    if (this.customLogin != null) {
      return this.customLogin.primaria;
    }
  }

  getButtonSecundaria() {
    if (this.customLogin != null) {
      return this.customLogin.secundaria;
    }
  }

  getButtonTerciario() {
    if (this.customLogin != null) {
      return this.customLogin.terciario;
    }
  }
}
